import { observer } from "mobx-react-lite";
import './DetailBar.scss'

export const DetailBarStripe = observer(({ children }) => {
    return <div className="DetailBar__stripe">
        {children}
    </div>
})

const DetailBar = observer(({ children, icon }) => {
    return (
        <div className="DetailBar">

            {icon ? <div className="DetailBar__icon">{icon}</div> : null}
            {
                children
            }
        </div>
    )
});

export default DetailBar